import { Component, Inject, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { UtilsService } from "../../shared/utils.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NetworkedEmployeesSelectorComponent } from "../../shared/networked-employees-selector/networked-employees-selector.component";
import { ToolboxTalksTemplatesFilters } from "./toolbox-talks-templates-filters.interface";

@Component({
  selector: 'app-toolbox-talks-templates-filter',
  templateUrl: './toolbox-talks-templates-filter.component.html',
  styleUrls: ['./toolbox-talks-templates-filter.component.scss']
})
export class ToolboxTalksTemplatesFilterComponent implements OnInit {

  // Set default filter values.
  filters: ToolboxTalksTemplatesFilters = {
    template_type: '',
    date_range: [],
    employee_ids: []
  };

  constructor(
    public location: Location,
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ToolboxTalksTemplatesFilterComponent>
  ) { }

  ngOnInit() {
    this.filters.template_type = this.data['template_type'] || '';
    this.filters.employee_ids = this.data['employee_ids'] || [];
    this.filters.date_range = this.data['date_range'] || [];
  }

  /**
   * Sets the output date range for the filters.
   *
   * @param {any} event - The event object containing the new date range.
   * @return {void}
   */
  getOutputDateRange(event: any): void {
    this.filters.date_range = event;
  }

  /**
   * Displays a dialog to select multiple employees and updates the filters with the selected employee IDs.
   *
   * @return {void}
   */
  onSelectEmployees(): void {
    this.utils.showComponentDialog(NetworkedEmployeesSelectorComponent, {
      selected: this.filters.employee_ids,
      multiple: true
    }, {
      width: '1200px'
    }, (results: number[]): void => {
      if ( !results ) { return; }
      this.filters.employee_ids = results;
    });
  }

  /**
   * Clears all values in the filters object and calls the onSaveAndClose method.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear all values.
    this.filters.template_type = '';
    this.filters.employee_ids = [];
    this.filters.date_range = [];
    // Save and close.
    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @returns {void}
   */
  onSaveAndClose(): void {
    this.dialogRef.close(this.filters);
  }

  /**
   * Clears the date range.
   *
   * @returns {void}
   */
  onClearDateRange(): void {
    this.filters.date_range = [];
  }
}
